// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qdrant-header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
}

/* Make collection-browser span full width within settings-section */
.settings-section .collection-browser {
  width: 100%;
  margin-top: 0;
}

.upload-button {
  padding: 10px 20px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.2);
}

.upload-button:hover {
  background: #1565c0;
  box-shadow: 0 3px 6px rgba(25, 118, 210, 0.3);
  transform: translateY(-1px);
}

.delete-all-button {
  padding: 10px 20px;
  background: #d32f2f;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(211, 47, 47, 0.3);
  white-space: nowrap;
}

.delete-all-button:hover:not(:disabled) {
  background: #b71c1c;
  box-shadow: 0 3px 6px rgba(211, 47, 47, 0.4);
  transform: translateY(-1px);
}

.delete-all-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #ccc;
  box-shadow: none;
}

.collections-sidebar {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: fit-content;
}

.collections-sidebar h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 18px;
}

.collection-item {
  width: 100%;
  padding: 12px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;
  box-sizing: border-box;
}

.collection-item:hover {
  background: #e0e0e0;
}

.collection-item.active {
  background: #1976d2;
  color: white;
  border-color: #1976d2;
}

.collection-name {
  font-weight: 600;
  margin-bottom: 5px;
}

.collection-stats {
  font-size: 12px;
  display: flex;
  gap: 10px;
  opacity: 0.8;
}

.documents-content {
  background: white;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-height: 500px;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

.documents-content h3 {
  margin: 0 0 24px 0;
  color: #1a1a1a;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.3px;
}

.documents-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.document-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.document-info {
  flex: 1 1;
  min-width: 0;
}

.document-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  word-break: break-word;
}

.document-meta {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.document-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.document-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  padding: 4px 8px;
  background: #1976d2;
  color: white;
  border-radius: 12px;
  font-size: 11px;
}

.delete-button {
  padding: 8px 16px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  flex-shrink: 0;
}

.delete-button:hover {
  background: #d32f2f;
}

.document-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.preview-button {
  padding: 8px 16px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.preview-button:hover {
  background: #1565c0;
}

.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.preview-modal-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.preview-header h3 {
  margin: 0;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  color: #666;
  line-height: 1;
}

.close-button:hover {
  color: #333;
}

.preview-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.preview-description,
.preview-tags {
  font-size: 14px;
  color: #666;
}

.preview-text {
  margin-top: 10px;
}

.preview-text pre {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 400px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.6;
}

.preview-note {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  font-style: italic;
}

.loading,
.no-documents {
  text-align: center;
  padding: 40px;
  color: #666;
}

.upload-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.file-upload-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.3s ease;
}

.file-upload-area:hover {
  border-color: #1976d2;
  background: #f0f7ff;
}

.file-upload-area.dragging {
  border-color: #1976d2;
  background: #e3f2fd;
  border-style: solid;
}

.file-upload-area.has-file {
  border-color: #4caf50;
  background: #f1f8e9;
}

.upload-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.browse-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}

.browse-link:hover {
  color: #1565c0;
}

.upload-hint {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.file-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.file-name {
  font-weight: 600;
  color: #333;
  flex: 1 1;
  text-align: left;
}

.file-size {
  color: #666;
  font-size: 14px;
}

.remove-file {
  background: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-file:hover {
  background: #d32f2f;
}

.file-preview {
  margin-top: 15px;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.file-preview strong {
  display: block;
  margin-bottom: 10px;
  color: #333;
}

.file-preview pre {
  background: white;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 200px;
  overflow-y: auto;
  font-size: 12px;
  line-height: 1.5;
  margin: 0;
}

.upload-modal-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.upload-modal-content h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 20px;
}

.upload-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group textarea {
  resize: vertical;
}

.upload-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.upload-submit {
  flex: 1 1;
  padding: 12px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.upload-submit:hover:not(:disabled) {
  background: #1565c0;
}

.upload-submit:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.upload-cancel {
  flex: 1 1;
  padding: 12px;
  background: #666;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.upload-cancel:hover {
  background: #555;
}

@media (max-width: 768px) {
  .qdrant-management {
    grid-template-columns: 1fr;
  }

  .qdrant-header {
    grid-template-columns: 1fr;
  }

  .qdrant-header h2 {
    grid-column: 1;
  }

  .qdrant-header-actions {
    grid-column: 1;
    margin-top: 12px;
    justify-content: flex-start;
  }

  .collections-sidebar {
    order: 2;
  }

  .documents-content {
    order: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/QdrantManagement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":[".qdrant-header-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n/* Make collection-browser span full width within settings-section */\n.settings-section .collection-browser {\n  width: 100%;\n  margin-top: 0;\n}\n\n.upload-button {\n  padding: 10px 20px;\n  background: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.2);\n}\n\n.upload-button:hover {\n  background: #1565c0;\n  box-shadow: 0 3px 6px rgba(25, 118, 210, 0.3);\n  transform: translateY(-1px);\n}\n\n.delete-all-button {\n  padding: 10px 20px;\n  background: #d32f2f;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(211, 47, 47, 0.3);\n  white-space: nowrap;\n}\n\n.delete-all-button:hover:not(:disabled) {\n  background: #b71c1c;\n  box-shadow: 0 3px 6px rgba(211, 47, 47, 0.4);\n  transform: translateY(-1px);\n}\n\n.delete-all-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #ccc;\n  box-shadow: none;\n}\n\n.collections-sidebar {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: fit-content;\n}\n\n.collections-sidebar h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.collection-item {\n  width: 100%;\n  padding: 12px;\n  margin-bottom: 10px;\n  background: #f5f5f5;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.collection-item:hover {\n  background: #e0e0e0;\n}\n\n.collection-item.active {\n  background: #1976d2;\n  color: white;\n  border-color: #1976d2;\n}\n\n.collection-name {\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.collection-stats {\n  font-size: 12px;\n  display: flex;\n  gap: 10px;\n  opacity: 0.8;\n}\n\n.documents-content {\n  background: white;\n  padding: 32px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.documents-content h3 {\n  margin: 0 0 24px 0;\n  color: #1a1a1a;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n}\n\n.documents-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.document-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 15px;\n  background: #f5f5f5;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.document-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.document-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n  word-break: break-word;\n}\n\n.document-meta {\n  display: flex;\n  gap: 15px;\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.document-description {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.document-tags {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tag {\n  padding: 4px 8px;\n  background: #1976d2;\n  color: white;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n.delete-button {\n  padding: 8px 16px;\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.delete-button:hover {\n  background: #d32f2f;\n}\n\n.document-actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.preview-button {\n  padding: 8px 16px;\n  background: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.preview-button:hover {\n  background: #1565c0;\n}\n\n.preview-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.preview-modal-content {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  max-width: 800px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.preview-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 32px;\n  cursor: pointer;\n  color: #666;\n  line-height: 1;\n}\n\n.close-button:hover {\n  color: #333;\n}\n\n.preview-body {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.preview-description,\n.preview-tags {\n  font-size: 14px;\n  color: #666;\n}\n\n.preview-text {\n  margin-top: 10px;\n}\n\n.preview-text pre {\n  background: #f5f5f5;\n  padding: 15px;\n  border-radius: 4px;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 400px;\n  overflow-y: auto;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.preview-note {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #999;\n  font-style: italic;\n}\n\n.loading,\n.no-documents {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.upload-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.file-upload-area {\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  padding: 40px;\n  text-align: center;\n  background: #fafafa;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.file-upload-area:hover {\n  border-color: #1976d2;\n  background: #f0f7ff;\n}\n\n.file-upload-area.dragging {\n  border-color: #1976d2;\n  background: #e3f2fd;\n  border-style: solid;\n}\n\n.file-upload-area.has-file {\n  border-color: #4caf50;\n  background: #f1f8e9;\n}\n\n.upload-icon {\n  font-size: 48px;\n  margin-bottom: 10px;\n}\n\n.browse-link {\n  color: #1976d2;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.browse-link:hover {\n  color: #1565c0;\n}\n\n.upload-hint {\n  font-size: 12px;\n  color: #999;\n  margin-top: 10px;\n}\n\n.file-selected {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.file-name {\n  font-weight: 600;\n  color: #333;\n  flex: 1;\n  text-align: left;\n}\n\n.file-size {\n  color: #666;\n  font-size: 14px;\n}\n\n.remove-file {\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.remove-file:hover {\n  background: #d32f2f;\n}\n\n.file-preview {\n  margin-top: 15px;\n  padding: 15px;\n  background: #f5f5f5;\n  border-radius: 4px;\n  border: 1px solid #e0e0e0;\n}\n\n.file-preview strong {\n  display: block;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.file-preview pre {\n  background: white;\n  padding: 10px;\n  border-radius: 4px;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-height: 200px;\n  overflow-y: auto;\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.upload-modal-content {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.upload-modal-content h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.upload-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  resize: vertical;\n}\n\n.upload-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.upload-submit {\n  flex: 1;\n  padding: 12px;\n  background: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.upload-submit:hover:not(:disabled) {\n  background: #1565c0;\n}\n\n.upload-submit:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.upload-cancel {\n  flex: 1;\n  padding: 12px;\n  background: #666;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.upload-cancel:hover {\n  background: #555;\n}\n\n@media (max-width: 768px) {\n  .qdrant-management {\n    grid-template-columns: 1fr;\n  }\n\n  .qdrant-header {\n    grid-template-columns: 1fr;\n  }\n\n  .qdrant-header h2 {\n    grid-column: 1;\n  }\n\n  .qdrant-header-actions {\n    grid-column: 1;\n    margin-top: 12px;\n    justify-content: flex-start;\n  }\n\n  .collections-sidebar {\n    order: 2;\n  }\n\n  .documents-content {\n    order: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
